import Big from 'big.js';
const between = (min, max, val) => val >= min && val <= max;
export const lessThanMax = (calc, max) => {
    if (max === 0 && calc.lte(max))
        return true;
    if (max && calc.lte(max))
        return true;
    if (!max && max !== 0 && calc.lte(Number.MAX_SAFE_INTEGER))
        return true;
    return false;
};
export const moreThanMin = (calc, min) => {
    if (min === 0 && calc.gte(min))
        return true;
    if (min && calc.gte(min))
        return true;
    if (!min && min !== 0 && calc.gte(Number.MIN_SAFE_INTEGER))
        return true;
    return false;
};
export const getPlusStartValue = (step, max, min) => {
    let startValue = new Big(0);
    if (((min || min === 0) && (max || max === 0) && between(Number(min), Number(max), 0)) ||
        (!min && !max)) {
        startValue = new Big(0);
    }
    if (max && Number(max) < 0) {
        startValue = new Big(max);
    }
    if (min && Number(min) > 0) {
        startValue = new Big(min);
    }
    return startValue.minus(step);
};
export const getMinusStartValue = (step, max, min) => {
    let startValue = new Big(0);
    if (((min || min === 0) && (max || max === 0) && between(Number(min), Number(max), 0)) ||
        (!min && !max)) {
        startValue = new Big(0);
    }
    if (min && Number(min) > 0) {
        startValue = new Big(min);
    }
    if (max && Number(max) < 0) {
        startValue = new Big(max);
    }
    return startValue.plus(step);
};
